// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 48,
        /* Optional */
        // loadProductFirst: true,
    }
};

var prevIcon = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg>';

var nextIcon = '<?xml version="1.0" encoding="UTF-8"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg>';

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<span class="product-status sold-out">' + bcSfFilterConfig.label.sold_out + '</span>',
    'saleLabelHtml': '<span class="product-status sale">' + bcSfFilterConfig.label.sale + '</span>',
    'vendorHtml': '<div>{{itemVendorLabel}}</div>',

    // Grid Template
    'productGridItemHtml': '<div id="product_single" class="product-single col {{soldOutClass}} {{saleClass}}" data-product-id="{{itemId}}">' +
        '<span class="product-image {{secondImageClass}}">' +
        '<a href="{{itemUrl}}" class="grid-link">'+
        '<img {{imageSrc}}src="{{primaryImageDesktop}}" alt="{{itemTitle}}" class="img-fluid {{lazyloadClass}}" data-second-image="{{secondThumbUrl}}" />' +
        '</a>' +
        '{{itemTag}}' +
        '{{itemSaleLabel}}' +
        '{{itemSoldOutLabel}}' +
        '</span>' +

        '<span class="product-details">' +
        '<div class="product-title-wishlist">' +
        '{{itemPrice}}' +
        '{{itemWishlist}}' +
        '</div>' +
        '<h3 class="product-title"><a href="{{itemUrl}}">{{itemTitle}}</a></h3>' +
        '</span>' +
        '</div>',

    // Pagination Template
    'previousActiveHtml': '<span class="previous"><a href="{{itemUrl}}">' + prevIcon + '</a></span>',
    'previousDisabledHtml': '<span class="previous disabled">' + prevIcon + '</span>',
    'nextActiveHtml': '<span class="next"><a href="{{itemUrl}}">' + nextIcon + '</a></span>',
    'nextDisabledHtml': '<span class="next disabled">' + nextIcon + '</span>',
    'pageItemHtml': '<span class="page"><a href="{{itemUrl}}">{{itemTitle}}</a></span>',
    'pageItemSelectedHtml': '<span class="page current">{{itemTitle}}</span>',
    'pageItemRemainHtml': '<span class="page">{{itemTitle}}</span>',
    'paginateHtml': '<div class="pagination">{{previous}}{{pageItems}}{{next}}</div>',

    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    data.price_min *= 100, data.price_max *= 100, data.compare_at_price_min *= 100, data.compare_at_price_max *= 100; // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale

    //Calculate the percentage, based on the original price, and the new sale price
    var onSalePercentageRaw = (data.compare_at_price_min - data.price_min) / data.compare_at_price_min * 100;
    var onSalePercentage = Math.round(onSalePercentageRaw);
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    var firstVariantId = data['variants'][0].id;
    //console.log(data['images_info'][0].src);
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

        // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Add Thumbnail
    var screenSize = window.screen.width;
    if (screenSize < 576) {
        var primaryImage = images.length > 0 ? this.optimizeImage(data['images_info'][0].src, '360x360') : bcSfFilterConfig.general.no_image_url;
    } else if (screenSize < 768) {
        var primaryImage = images.length > 0 ? this.optimizeImage(data['images_info'][0].src, '485x485') : bcSfFilterConfig.general.no_image_url;
    } else if (screenSize < 992) {
        var primaryImage = images.length > 0 ? this.optimizeImage(data['images_info'][0].src, '420x420') : bcSfFilterConfig.general.no_image_url;
    } else if (screenSize < 1200) {
        var primaryImage = images.length > 0 ? this.optimizeImage(data['images_info'][0].src, '510x510') : bcSfFilterConfig.general.no_image_url;
    } else {
        var primaryImage = images.length > 0 ? this.optimizeImage(data['images_info'][0].src, '600x600') : bcSfFilterConfig.general.no_image_url;
        
    }
    itemHtml = itemHtml.replace(/{{primaryImageDesktop}}/g, primaryImage);

    // Add Thumbnail
    var itemThumbUrl = images.length > 0 ? data['images_info'][0].src : bcSfFilterConfig.general.no_image_url;
    itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

    var itemfullURL = this.buildProductItemUrl(data);

    var secondImageClass = ""

    // Second image
	if (images.length > 1) {
		var secondThumbUrl = this.optimizeImage(data['images_info'][1].src, '600x600');
        itemHtml = itemHtml.replace(/{{secondThumbUrl}}/g, secondThumbUrl);

        secondImageClass = "product-image-hover";
    } else {
        itemHtml = itemHtml.replace(/{{secondThumbUrl}}/g, '');
    }

    itemHtml = itemHtml.replace(/{{secondImageClass}}/g, secondImageClass);


    // Add Price
    var itemPriceHtml = '';
    if (data.title != '') {
        itemPriceHtml += '<span class="product-price">';

        if (priceVaries) {
            //itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        } else {
            itemPriceHtml += '<span class="money">' + this.formatMoney(data.price_min) + '</span>';
        }
        if (onSale) {
            itemPriceHtml += '<span class="product-price-original">WAS <span class="money">' + this.formatMoney(data.compare_at_price_min) + '</span></span> ';
        }
        itemPriceHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add lazy loading to products below the fold
    if (index <= 4) {
        itemHtml = itemHtml.replace(/{{imageSrc}}/g, '');
        itemHtml = itemHtml.replace(/{{lazyloadClass}}/g, '');
    } else {
        itemHtml = itemHtml.replace(/{{imageSrc}}/g, 'data-');
        itemHtml = itemHtml.replace(/{{lazyloadClass}}/g, 'lazyload');
    }

    //Variant Support
    var itemVariantHtml = '';
    if (data.variant != '') {

        itemVariantHtml += '<span class="product-variants"><span class="product-variants-title">Size\'s Available:</span><ul>';

        //define vars for variant data to capture
        var variantAvailable = '',
            variantTitle = '',
            variantID = '';

        //loop through available variants
        for (var key in data['variants']) {
            if (data['variants'].hasOwnProperty(key)) {
                var obj = data['variants'][key];
                //for each variant, loop through the available properties.

                for (var prop in obj) {

                    if (obj.hasOwnProperty(prop)) {
                        //Store properties as vars
                        if (prop == "available") {
                            variantAvailable = obj[prop];
                        }
                        if (prop == "title") {
                            variantTitle = obj[prop];
                        }
                        if (prop == "id") {
                            variantID = obj[prop];
                        }

                    }
                }
                //for each variant, output into markup.
                itemVariantHtml += '<li class="variant-available-' + variantAvailable + '"><a href="' + itemfullURL + '?variant=' + variantID + '">' + variantTitle + '</a></li>';
            }
        }


        itemVariantHtml += '</ul></span>';
    }

    itemHtml = itemHtml.replace(/{{itemVariants}}/g, itemVariantHtml);

    var itemTagHtml = '';
    if (data.tag != '') {

        //loop through available variants
        for (var key in data['tags']) {


            if (data['tags'].hasOwnProperty(key)) {
                var obj = data['tags'][key];

                if (obj.includes("collection_colours_")) {
                    getProductRangeColours(data.id, obj)
                }
                //for each variant, loop through the available properties.

                //    if (obj.toUpperCase() == "NEW IN" || "NEW-IN") {
                //         itemTagHtml = '<span class="product-status new-in">New In</span>';
                //    }

                if ((obj.toUpperCase() === "BACKINSTOCK")) {
                    itemTagHtml = '<span class="product-status backinstock">Back In Stock</span>';
                }
            }
        }
    }

    itemHtml = itemHtml.replace(/{{itemTag}}/g, itemTagHtml);

    // Add soldOut class
    var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

    // Add onSale class
    var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

    // Add soldOut Label
    var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
    itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);


    // Add onSale Label
    if (onSale) {
        var itemSaleHtml = '<span class="product-status sale">' + onSalePercentage + '% off</span>';
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleHtml);
    } else {
        itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, '');
    }


    var itemWishList = '<span class="product-wishlist"><span class="smartwishlist" data-product="' + data.id + '" data-variant="' + firstVariantId + '"></span></span>'
    itemHtml = itemHtml.replace(/{{itemWishlist}}/g, itemWishList);

    //var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
    //itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

    // Add Vendor
    //var itemVendorHtml = bcSfFilterConfig.custom.vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, data.vendor);

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));


    //pass over product id to productColors app
    //ajaxProductColors(data.id, data.handle);

    return itemHtml;
};

function getProductRangeColours(productID, tag) {
    $.ajax({
        method: 'GET',
        url: '/collections/all/' + tag + '?view=json',

        success: function (data) {
            if(data) {
                try {
                    var json = JSON.parse(data);
                } catch(e) {
                    var json = null; // meh
                }
            }
            if (json) {
                var itemVariantHtml = '';
                var totalItems = 0;

                for (var key in json.products) {
                    if (totalItems == 4) {
                        itemVariantHtml = `<div class="colourswatch-wrapper">${itemVariantHtml}</div>`;
                        break;
                    }
                    itemVariantHtml += '<div class="colourswatch-container">';
                    itemVariantHtml += '<a href="' + json.products[key]['url'] + '"><div title="' + json.products[key]['title'] + '" class="colourswatch ' + json.products[key]['colour'].toLowerCase() + ' ' + json.products[key]['title'].split(' ').pop().replaceAll('-', '').toLowerCase() +'"></div></a>';
                    itemVariantHtml += '</div>';
                    totalItems++;
                }
                
                $('#bc-sf-filter-products #product_single[data-product-id="' + productID + '"] .product-details').append(itemVariantHtml);
            }
        }
    });

}


// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function (data) {
    // // Add Description
    // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
    // // Truncate by word
    // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
    // // Truncate by character
    // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
    // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData = function (data) {
    for (var k in data) {
        // Featured image
        if (data['images_info'] > 0) {
            data[k]['featured_image'] = data['images_info'][0];
        } else {
            data[k]['featured_image'] = {width: '', height: '', aspect_ratio: 0}
        }

        // Add Options
        var optionsArr = [];
        for (var i in data[k]['options_with_values']) {
            optionsArr.push(data[k]['options_with_values'][i]['name']);
        }
        data[k]['options'] = optionsArr;

        // Customize variants
        for (var i in data[k]['variants']) {
            var variantOptionArr = [];
            var count = 1;
            var variant = data[k]['variants'][i];
            // Add Options
            var variantOptions = variant['merged_options'];
            if (Array.isArray(variantOptions)) {
                for (var j = 0; j < variantOptions.length; j++) {
                    var temp = variantOptions[j].split(':');
                    data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];
                    data[k]['variants'][i]['option_' + temp[0]] = temp[1];
                    variantOptionArr.push(temp[1]);
                }
                data[k]['variants'][i]['options'] = variantOptionArr;
            }
            data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;
            data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100;
        }

        // Add Description
        data[k]['description'] = data[k]['body_html'];
    }
    return data;
};

/************************** END BUILD PRODUCT LIST **************************/

// Build Pagination
BCSfFilter.prototype.buildPagination = function (totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/

//BG: Custom functionality to allow the user to hover on products with more mulitple size variants.
function variantHover() {
    //define the products
    var collectionProduct = $('.product-single');
    //for each product
    collectionProduct.each(function () {
        //get the available variants
        var productVariants = $(this).find('.product-variants > ul > li');
        //if there's more than one variant, add the has-variants class.
        if (productVariants.length > 1) {
            $(this).addClass('has-variants');
        }
    });
}

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
    variantHover();
};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    collectionProductHover();
};

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
